var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPaperEdit = function SvgPaperEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#232322",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M11.106 26.756H3.284A1.955 1.955 0 0 1 1.328 24.8V3.29a1.956 1.956 0 0 1 1.956-1.957h19.555a1.955 1.955 0 0 1 1.956 1.956v8.8M11.105 7.2h7.823M7.195 13.067h11.733M7.195 18.933h9.777m12.882.809-9.943 9.947-4.889.978.978-4.89 9.948-9.946a2.755 2.755 0 0 1 3.9 0l.012.01a2.76 2.76 0 0 1-.006 3.9",
    vectorEffect: "non-scaling-stroke"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
};
export default SvgPaperEdit;